export const preventFormsInteraction = (fieldsetEls = [], prevent = true) => {
  if (!fieldsetEls) return null;

  const fieldsetsAreNodelist = fieldsetEls instanceof NodeList || Array.isArray(fieldsetEls);
  if (!fieldsetsAreNodelist) return null;

  fieldsetEls.forEach((fieldsetEl) => {
    const fieldsetIsNode = fieldsetEl instanceof Node;
    if (!fieldsetIsNode) return null;
    fieldsetEl.disabled = prevent;
    fieldsetEl.classList[prevent ? "add" : "remove"]("loading");
  });
};
